import { useCallback, useMemo } from 'react'
import { useRootContext } from 'app/services/RootProvider/RootProvider'
import { getErrorStatus } from 'app/util/errorCodes'
import submitClaimWithShipping from './actions/submitClaimWithShipping'

/**
 * The `useClaimables` hook is used to manage submission of
 * claimable (redemption) rewards from the users account
 *
 * @param {object} account - the account detail
 * @returns {object} the context object
 */
function useClaimables (account) {
  const { appActivityStatus, setAppActivityStatus } = useRootContext()

  /**
   * Claim a physical product with shipping
   *
   * @param {object} formData - the precompiled form data
   * @returns {Promise} resolves on completion
   */
  const claimWithShipping = useCallback(
    async formData => {
      if (appActivityStatus) {
        // Defensive when busy
        return
      }

      let res = null

      setAppActivityStatus('BUSY')

      try {
        res = await submitClaimWithShipping(formData)
      } catch (e) {
        console.error(e)
        setAppActivityStatus(null)

        return getErrorStatus('UNKNOWN')
      }

      setAppActivityStatus(null)

      return res
    },
    [account, appActivityStatus]
  )
  /**
   * Memo: the context object
   */
  const ctx = useMemo(
    () => ({
      claimWithShipping
    }),
    [claimWithShipping]
  )

  return ctx
}

// export
export default useClaimables
